import { BaseController } from "./common/base/controller";
import { ProgressableStates } from "./app.state";

import { HIDDEN_HEADER_STATES } from "./app.constants";

export default class AppController extends BaseController {
	showHeader = true;

	constructor(controllerService, configService, $http, $transitions) {
		"ngInject";
		super({
			controllerService,
			configService,
			$http,
			$transitions,
		});

		this.onStateChange();
	}

	$onInit() {
		// Assign the resolved languageOptions to the base controller service,
		// therefor every controller will have access to the languageOptions.
		this.controllerService.languageOptions = this.languageOptions;

		this.$transitions.onSuccess({}, this.onStateChange.bind(this));

		const hasStatusPage = this.configService.isFeatureActive(
			this.Features.hasStatusPage,
		);

		// Set visible progress states to progressbar
		this.progressbarStates = ProgressableStates(hasStatusPage);
	}

	onStateChange(transition) {
		this.showHeader = !HIDDEN_HEADER_STATES.includes(this.currentState.name);
	}
}



// WEBPACK FOOTER //
// ./src/app/app.controller.js